import React, { useEffect, useRef, useState } from 'react';
import { useTracksQuery } from './queries/Tracks';
import { SearchBox } from './SearchBox';
import { TrackCard } from './TrackCard';

const AFTER_REQUEST_MS = 6_000;

const RESET_EVENT = 'songrequests:reset';
const REQUESTED_EVENT = 'songrequests:requested';

export function TrackList() {
  const { data: tracks } = useTracksQuery();
  const [searchTerm, setSearchTerm] = useState('');

  const searchTermRef = useRef(searchTerm);
  useEffect(() => {
    searchTermRef.current = searchTerm;
  }, [searchTerm]);

  useEffect(() => {
    let afterRequestTimer: number | undefined;
    let afterRequestArmed = false;

    const resetToBeginningIfNeeded = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const term = searchTermRef.current;

      const hasSearch = !!term && term.trim() !== '';
      const isScrolled = y > 0;

      window.dispatchEvent(new Event(RESET_EVENT));

      if (!hasSearch && !isScrolled) return;

      if (hasSearch) setSearchTerm('');

      if (isScrolled) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    const onRequested = () => {
      afterRequestArmed = true;

      if (afterRequestTimer) window.clearTimeout(afterRequestTimer);
      afterRequestTimer = window.setTimeout(() => {
        if (!afterRequestArmed) return;
        resetToBeginningIfNeeded();
      }, AFTER_REQUEST_MS);
    };

    window.addEventListener(REQUESTED_EVENT, onRequested);

    return () => {
      if (afterRequestTimer) window.clearTimeout(afterRequestTimer);
      window.removeEventListener(REQUESTED_EVENT, onRequested as any);
    };
  }, []);

  const filteredTracks = tracks?.filter((track) =>
    track.artistTitle.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="w-full max-w-4xl p-6 space-y-4 relative">
      <center>
        <h1 className="text-2xl lg:text-3xl font-bold text-white mb-6">
          Make Your Request...
        </h1>
      </center>

      <SearchBox
        value={searchTerm}
        onChange={setSearchTerm}
        placeholder="Search tracks..."
      />

      <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {filteredTracks?.map((track) => (
          <TrackCard key={track.guid} track={track} />
        ))}
      </div>
    </div>
  );
}
